module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus-mobile.f9a5b1ca.png";